<template>
  <div>
    <h3>What is your gender?</h3>
    <v-form-group class="card-selector" :validator="$v.gender">
      <b-form-radio v-model="survey.gender" name="genders" :value=genderType.Male>
        <svg-icon name="male"/> Male
      </b-form-radio>
      <b-form-radio v-model="survey.gender" name="genders" :value=genderType.Female>
        <svg-icon name="female" /> Female
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import gender from "enums/gender";

  export default {
    mixins: [formMixin],
    data() {
      return {
        genderType: gender,
      };
    },

    validations: {
      gender: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      gender() { return this.survey.gender }
    },

    methods: {
      onSubmit() {

      }
    }
  };
</script>